import { render, staticRenderFns } from "./CarteiraRelatorio.vue?vue&type=template&id=db99271a&"
import script from "./CarteiraRelatorio.vue?vue&type=script&lang=js&"
export * from "./CarteiraRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./CarteiraRelatorio.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CarteiraRelatorio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports